import { useContext } from 'react'
import BoardContext from './BoardContext'

const useBoardContext = () => {
  return useContext(BoardContext)
}

export default useBoardContext